<template>
     <div class="col-sm-12 col-xl-6">
                <div class="card">
                  <div class="card-header pb-0">
                    <h4>All Close Accordion</h4><span>Using the <a href="#">card</a> component, you can extend the default collapse behavior to create an accordion.</span>
                  </div>
                  <div class="card-body">
                    <div class="default-according" id="accordionclose">
                      <div class="card">
                        <div class="card-header" id="heading1">
                          <h5 class="mb-0">
                            <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="heading1">Collapsible Group Item #<span>1</span></button>
                          </h5>
                        </div>
                        <div class="collapse" id="collapse1" aria-labelledby="heading1" data-bs-parent="#accordionclose">
                          <div class="card-body">{{desc}}</div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading2">
                          <h5 class="mb-0">
                            <button class="btn btn-link ps-0 collapsed" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="heading2">Collapsible Group Item #<span>2</span></button>
                          </h5>
                        </div>
                        <div class="collapse" id="collapse2" aria-labelledby="heading2" data-bs-parent="#accordionclose">
                          <div class="card-body">{{desc}}</div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading3">
                          <h5 class="mb-0">
                            <button class="btn btn-link ps-0 collapsed" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">Collapsible Group Item #<span>3</span></button>
                          </h5>
                        </div>
                        <div class="collapse" id="collapse3" aria-labelledby="heading3" data-bs-parent="#accordionclose">
                          <div class="card-body">{{desc}}</div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading4">
                          <h5 class="mb-0">
                            <button class="btn btn-link ps-0 collapsed" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">Collapsible Group Item #<span>4</span></button>
                          </h5>
                        </div>
                        <div class="collapse" id="collapse4" aria-labelledby="heading4" data-bs-parent="#accordionclose">
                          <div class="card-body">{{desc}}</div>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-header" id="heading5">
                          <h5 class="mb-0">
                            <button class="btn btn-link ps-0 collapsed" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">Collapsible Group Item #<span>5</span></button>
                          </h5>
                        </div>
                        <div class="collapse" id="collapse5" aria-labelledby="heading5" data-bs-parent="#accordionclose">
                          <div class="card-body">{{desc}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
</template>
<script>
export default {
    data(){
        return{
            desc:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS."
        }
    }
}
</script>